export const api = {
  syncAuthorityGroup: "/bms/turnstilegate/syncTurnstilegateRightGroup.json", //同步权限组
  getGroup: "/bms/turnstilegate/queryTurnstilegateRightGroupList.json", //获取权限组
  getPeople: "/bms/turnstilegate/queryTurnstilegatePersonnelList.json", //添加人员的来源
  getAuthorityList: "/bms/turnstilegate/queryTurnstilegateAuthorityList.json", // 获取权限组下员工列表
  updateAuthority: "/bms/turnstilegate/updateTurnstilegateAuthority.json", // 修改人员授权
  addAuthority: "/bms/turnstilegate/addTurnstilegateAuthority.json", //新增人员授权
  device: {
    getGateTree: "/bms/device/queryDeviceTree.json", //出入口授权-人员通行权限，查询人脸闸机设备树
    departmentTree: "/vas/department/queryDepartmentTree.json" //部门树
  },
  person: {
    getPersonList: "/vas/personnel/queryPersonListApi.json", //获取员工列表
    getAuthorityList: "/bms/turnstilegate/queryTurnstilegateAuthorityList.json", // 获取员工授权列表
    updateAuthority: "/bms/turnstilegate/updateTurnstilegateAuthority.json", // 修改人员授权
    addAuthority: "/bms/turnstilegate/addTurnstilegateAuthority.json", //新增人员授权
    deleteAuthority: "/bms/turnstilegate/deleteTurnstilegateAuthority.json", //删除人员授权
    syncAuthorityList: "/bms/turnstilegate/syncTurnstilegatePersonnel.json", //人员授权页面同步
    getRecordList:
      "/bms/turnstilegate/queryTurnstilegateAuthorityRecordList.json", //详情页面授权信息列表接口
    exportTurnstilegateAuthorityList:
      "/bms/turnstilegate/exportTurnstilegateAuthorityList.json" //人员导出
  }
};
